export default __webpack_public_path__ + "static/media/arrow.6e5063c1.svg";